module.exports = __webpack_public_path__ + "static/media/ldi-success-image.8eafa045.svg";